async function orderLimits() {    

  const path = window.location.pathname;
  if (path == '/') {
    //we are on homepage
    //do not add products with limits to featured products atm
    //to fix this we need to import order limit variables to featured product section
    return Promise.resolve(true);
  } else {
    // read our JSON
    let response = await fetch('/cart.js');
    let cart = await response.json();
  
    //Order limits code
    //product order limits
    var variant_qty = document.getElementById("Quantity").value;
    var prod_meta = JSON.parse(document.getElementById("product-metafields").text);
    var product_max = prod_meta.metafields.variant_max;
    var product_id = prod_meta.metafields.prod_id;
    var quantityIsAvailable = true;   

    //product variant order limits
    var variantFlag = false;
    var vari_meta = JSON.parse(document.getElementById("product-variant-metafields").text);
    var selected_id = document.getElementById('selected-variant').value;

    for (var i = 0; i < vari_meta.metafields.length; i++ ) {
      if (vari_meta.metafields[i].id == selected_id) {
        //only override product if there is one set for variant
        if (vari_meta.metafields[i].variant_max !== 9999) {
          var variantFlag = true;
          var product_max = vari_meta.metafields[i].variant_max;
        }       
      }
    }
    
    //if product_max is set
    if (product_max !== null) {
      //check if qualtity is greater that max limits
      if (variant_qty > product_max) {
        //error message          
        document.querySelector('.product-form__error-message')
          .innerHTML = 'You can only add '+product_max+' of this item to your cart.';
        document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden');           
        return Promise.resolve(false);
      } else {
        //if basket isnt empty
        var basket_size = cart.items.length;
        if (basket_size > 0) {
          var basket_size = basket_size - 1;
          //check whether item is already in cart. If so how many
          for (var i = 0; i <= basket_size; i++ ) {
            var lineItem = cart.items[i]; 
            var quantity = cart.items[i].quantity;
            if (lineItem.product_id  == product_id) {
              //we have a matching product
              if (!variantFlag) {
                //varient flag is false
                //so no overrides             
                if (quantity >= product_max) {
                  //if max item is in the cart already
                  //error message          
                  document.querySelector('.product-form__error-message')
                    .innerHTML = 'All '+product_max+' '+lineItem.title+' are in your cart.';
                  document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden');                    
                  return Promise.resolve(false);
                } else {
                  //if some are in the cart
                  var x = product_max - quantity;
                  if (x < variant_qty) {
                    //error message          
                    document.querySelector('.product-form__error-message')
                      .innerHTML = 'You can only add '+ x +' '+lineItem.title+' to the cart.';
                    document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden');                   
                    return Promise.resolve(false);
                  }
                }                 
              } else {
                if (lineItem.variant_id == selected_id) {
                  if (quantity >= product_max) {
                    //if max item is in the cart already
                    //error message          
                    document.querySelector('.product-form__error-message')
                      .innerHTML = 'All '+product_max+' '+lineItem.title+' are in your cart.';
                    document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden');                    
                    return Promise.resolve(false);
                  } else {
                    //if some are in the cart
                    var x = product_max - quantity;
                    if (x < variant_qty) {
                      //error message          
                      document.querySelector('.product-form__error-message')
                        .innerHTML = 'You can only add '+ x +' '+lineItem.title+' to the cart.';
                      document.querySelector('.product-form__error-message-wrapper').toggleAttribute('hidden');                   
                      return Promise.resolve(false);
                    }
                  }   
                }                
              }
            }
        
            if (!quantityIsAvailable || i == basket_size) {
              //console.log(quantityIsAvailable+' about to break');
              return Promise.resolve(true);
              break;
            }
          }  
        } else {  
          //basket is empty
          return Promise.resolve(true);
        }            
      }
    } else {    
      return Promise.resolve(true);
    }  
  }
}
                         

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    } 
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // ✅ Capture only the button's text (excluding the spinner)
      const originalButtonText = submitButton.textContent.trim();

      // ✅ Store the existing spinner so we can re-add it
      const loadingSpinner = submitButton.querySelector('.loading-overlay__spinner');
      
      orderLimits()
        .then((response) => {
          if (response) {
            //passed order limits. response is true
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });

            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
                  return;
                }        
                    
              //console.log(response);
              // this.cartNotification.renderContents(response);
              // Check if the current page is the cart page
              if (window.location.pathname === '/cart') {
                // Refresh the page to update cart contents
                //window.location.reload();

                // ✅ Update button text to "Added!"
                submitButton.textContent = "Added!";
                if (loadingSpinner) submitButton.appendChild(loadingSpinner);
                //submitButton.classList.add("added-success");
    
                this.updateCartUI();
                
                // ✅ Reset the button text after 2 seconds
                setTimeout(() => {
                  submitButton.textContent = originalButtonText;
                    if (loadingSpinner) submitButton.appendChild(loadingSpinner);
                }, 2000);
              } else {
                this.cartNotification.renderContents(response); // Show cart drawer normally
            }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });              
            
          } else {
            //failed order limits. response is false  
          }
        }
      )
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });                    
    
  }

  updateCartUI() {
    fetch(`${routes.cart_url}?sections=main-cart-items`) // Fetch updated cart data
      .then(response => response.json())
      .then((data) => {
        //console.log("Cart API Response:", data); // Debugging

        // Ensure data is valid
        if (!data || typeof data !== "object") {
          console.error("Error: Invalid cart data received.", data);
          return;
        }

        const cartTableBody = document.querySelector('.cart-items tbody'); // Select only the tbody

        // ✅ Update only the cart items (inside tbody), keeping header & other elements
        if (cartTableBody && data['main-cart-items']) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data['main-cart-items']; 

          const updatedCartTableBody = tempDiv.querySelector('.cart-items tbody'); // Extract updated tbody

          if (updatedCartTableBody) {
            cartTableBody.innerHTML = updatedCartTableBody.innerHTML; // Replace only tbody contents
          } else {
            console.error("Error: Unable to find updated cart tbody.");
          }
        } else {
          console.error("Error: 'main-cart-items' section not found.", data);
        }

        //update subtotals
        fetch('/cart.js') // Get latest cart totals
          .then(response => response.json())
          .then(cart => {
            const subtotalElement = document.querySelector('.totals__subtotal-value');
            if (subtotalElement) {
              subtotalElement.innerHTML = `£${(cart.total_price / 100).toFixed(2)} GBP`;
              //console.log("✅ Subtotal fetched and updated:", cart.total_price / 100);
            } else {
              console.error("Error: Subtotal element not found.");
            }
          })
          .catch(error => console.error("Error fetching cart total:", error));

      })
      .catch((error) => console.error("Error updating cart:", error));
  }




    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
